import React, {useState, useEffect} from 'react'
import cn from "classnames"
import pageBg from  '../../img/train-page-bg.webp'
import modalBg from '../../img/modal-bg-2.svg'
import ticketImg from '../../img/ticket-img.webp'
import mountains from '../../img/train-mountains.webp'
import {Preloader, SpriteSvg} from '../../components'

const TrainPage = ({
	handleNextPage,
	name,
	setName,
	isLoaded,
	setIsLoaded,
	trainStationPage,
}) => {
const [isTicketOn, setIsTicketOn] = useState(false)
const [isVisibleContent, setIsVisibleContent] = useState(false)

	useEffect(()=> {
		setTimeout(()=> {
			setIsVisibleContent(true)
		},5000)
	},[])

	const onChangeHandler = event => {
		let btn = event.target.closest(".input-block").querySelector(".btn.red");

		setName(event.target.value);

		if (event.target.value.length >= 2) {
			btn.classList.remove("disabled");
		} else {
			btn.classList.add("disabled");
		}
	}

	return (
		<>
		<Preloader isLoaded={isLoaded} setIsLoaded={setIsLoaded}/>

		<div className={cn(
					 'full-page',
					 'train-page',
					 isLoaded && 'active'
				 )}
		>
			<div className="page-bg">
				<img className='mountain' src={mountains} alt=""/>
				<img className='bg-img' src={pageBg} alt=""/>
			</div>

			<div className={cn(
						 'page-content',
						 isVisibleContent &&
						 'active'
					 )}>
				<div style={{left: 'initial', right: '40px'}}
						 className={cn(
							 'modal',
							 isTicketOn &&
							 'disabled'
						 )}
				>
					<div className="modal-bg">
						<img src={modalBg} alt=""/>
					</div>
					<div className="modal-content">
						<div className="text">
								<p className='mg-b-8'>Наконец-то мне удалось вырваться из суеты безумного мира. Столько всего произошло, что пора бы перезагрузиться.</p>
								<p className='mg-b-8'>Всю жизнь я покоряю разные вершины, ставлю цели и иду к ним. Но мне всегда было мало. Сердце подсказывало, что главная цель ещё впереди!</p>
								<p className='mg-b-8'>Всё, чего я достиг, было лишь подготовкой к чему-то большему!</p>
								<p className='mg-b-12'>И это большее — пик ТЕХНОНИКОЛЬ!</p>
								<p className='mg-b-8'>За 30 лет вершина, где властвует стихия, поддалась единицам.</p>
								<p className='mg-b-8'>Я хочу повторить их успех — эта задача точно по мне!</p>
								<p className='mg-b-8'>Жду с нетерпением. Во сколько я прибываю?</p>

						</div>
						<div className="btn-wrap jcs">
							<div onClick={()=> {setIsTicketOn(true)}} className="btn green">
								<SpriteSvg id='button-bg'/>
								<span>Посмотреть время прибытия</span>
							</div>
						</div>
					</div>
				</div>

				<div className={cn(
							 'ticket-wrap',
					isTicketOn &&
					'active'
						 )}>
					<div className="ticket">
						<img src={ticketImg} alt=""/>
					</div>
					<div className="input-block">
						<div className="input-wrap mg-b-16">
							<input
								type="text"
								placeholder="Ваше имя"
								name="name"
								onChange={onChangeHandler}
								value={name}
							/>
						</div>
						<div onClick={()=> handleNextPage(trainStationPage)} className="btn red disabled">
							<SpriteSvg id='button-bg'/>
							<p>Прибытие</p>
						</div>
					</div>

			  </div>
			</div>

		</div>
		</>
	)
}

export default TrainPage